import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import * as Utils from "../Utils";
import { useSessionInfo } from "./../SessionInfo";
import { usePageVisibility } from "react-page-visibility";
import * as SessionInfo from "../SessionInfo";
import ErrorMessageDialog from "../configuration/dialog/ErrorMessageDialog";
import { useErrorMessageDialog } from "../configuration/dialog/ErrorMessageDialog";
var sessionMonitorPeriodMillis = 60000; // One minute

var SessionMonitor = function SessionMonitor(_ref) {
  var open = _ref.open,
    handleClose = _ref.handleClose;
  var _useSessionInfo = useSessionInfo(),
    _useSessionInfo2 = _slicedToArray(_useSessionInfo, 1),
    sessionInfo = _useSessionInfo2[0];
  var isVisible = usePageVisibility();
  var keepAliveTimeout = React.useRef(null);
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    keepAliveCounter = _React$useState2[0],
    setKeepAliveCounter = _React$useState2[1];
  var _useErrorMessageDialo = useErrorMessageDialog(),
    _useErrorMessageDialo2 = _slicedToArray(_useErrorMessageDialo, 2),
    errorMessage = _useErrorMessageDialo2[0],
    setErrorMessage = _useErrorMessageDialo2[1];
  React.useEffect(function () {
    var errorMessageOpen = errorMessage && errorMessage.open;
    if (isVisible && sessionInfo && !errorMessageOpen) {
      issueKeepAliveRequest();
    } else {
      unscheduleKeepAlive();
    }

    // Clear error message if session info does not exist (which means the user is currently viewing the login page)
    if (!sessionInfo && errorMessageOpen) {
      setErrorMessage(null);
    }
  }, [isVisible, sessionInfo, keepAliveCounter, errorMessage]);
  var unscheduleKeepAlive = function unscheduleKeepAlive() {
    if (keepAliveTimeout.current) {
      clearTimeout(keepAliveTimeout.current);
      keepAliveTimeout.current = null;
    }
  };
  var increaseKeepAliveCounter = function increaseKeepAliveCounter() {
    setKeepAliveCounter(keepAliveCounter + 1);
  };
  var scheduleKeepAlive = function scheduleKeepAlive() {
    unscheduleKeepAlive();
    keepAliveTimeout.current = setTimeout(increaseKeepAliveCounter, sessionMonitorPeriodMillis);
  };
  var issueKeepAliveRequest = function issueKeepAliveRequest() {
    var url = "application/auth/keepAlive";
    Utils.fetchData(url, null, false, false).then(function (response) {
      scheduleKeepAlive();
    }).catch(function (error) {
      setErrorMessage("Please log in again");
    });
  };
  var logout = function logout() {
    setErrorMessage(null);
    SessionInfo.clear();
  };
  return /*#__PURE__*/React.createElement(ErrorMessageDialog, Object.assign({}, errorMessage, {
    handleClose: logout,
    closeButtonLabel: "Ok",
    title: "Session expired"
  }));
};
export default SessionMonitor;